import { TermsCopy } from '@components/ui';
import Typography from '@mui/material/Typography';

interface AllTransactionsArbitrationSectionProps {
  titleKey?: string;
}

export function AllTransactionsArbitrationSection({
  titleKey = 'termsSections.allTransactionsArbitration.0',
}: AllTransactionsArbitrationSectionProps): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey={titleKey} />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.1" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.2" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.3" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.4" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.5" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.6" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.7" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.allTransactionsArbitration.8" />
      </Typography>
    </>
  );
}
